import { render, staticRenderFns } from "./user-recharge.vue?vue&type=template&id=077e544c&scoped=true"
import script from "./user-recharge.vue?vue&type=script&lang=js"
export * from "./user-recharge.vue?vue&type=script&lang=js"
import style0 from "./user-recharge.vue?vue&type=style&index=0&id=077e544c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077e544c",
  null
  
)

export default component.exports